/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_InstitutionsInputs */

const en__field_institutions = /** @type {(inputs: _Field_InstitutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institutions`)
};

const de__field_institutions = /** @type {(inputs: _Field_InstitutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institutionen`)
};

/**
* | output |
* | --- |
* | "Institutions" |
*
* @param {_Field_InstitutionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_institutions = /** @type {((inputs?: _Field_InstitutionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_InstitutionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_institutions(inputs)
	return de__field_institutions(inputs)
});